import { vnModule_knockoutJS } from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from '../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { header } from './header';
import { vn_app_zone_notification } from '../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification';
import { tagStore_template } from '../components/templates/tagStore_template';

declare var ko: any;
declare var page: any;

export class tagStore_helper extends vnModule_knockoutJS {
    protected getModuleName(): string {
        return 'tagStore_helper';
    }
    private caller: any;

    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdlCaller: string;
    public tagStore: tagStore_template;

    constructor(tagStore: tagStore_template, vnAppZone: any, caller: any) {
        super(vnAppZone);
        this.tagStore = tagStore;
        this.caller = caller;
    }

    buildContent(): Array<Element> {
        return [this.tagStore.build()];
    }

    protected onAutocompleteInputClick(idElement) {
        switch (idElement) {
            case 'tagTypeFilter':
                const tagType = this.tagStore.tagTypeFilter.getTemplateViewModel().optionObj();
                this.tagStore.updateSelectedTagType(tagType);
        }
    }

    protected onAutocompleteInputClear(idElement) {
        switch (idElement) {
            case 'tagTypeFilter':
                this.tagStore.updateSelectedTagType({});
        }
    }

    protected onAutocompleteOptionChange(idElement) {
        switch (idElement) {
            case 'tagTypeFilter':
                const tagType = this.tagStore.tagTypeFilter.getTemplateViewModel().optionObj();
                this.tagStore.updateSelectedTagType({
                    name: tagType ? tagType.name : null,
                    id: tagType ? tagType.id : null,
                    typeName: tagType ? tagType.typeName : null,
                    datasetName: tagType ? tagType.datasetName : null,
                    fields: tagType ? tagType.fields : null,
                    optionalReferenceFields: tagType ? tagType.optionalReferenceFields : null,
                });
        }
    }

    protected getSuggestions(keyword, idElement) {
        switch (idElement) {
            case 'tagTypeFilter':
                this.XHRHdlCaller = "getSuggestions_" + idElement;
                this.getTagTypeSuggestion(keyword, 5);
        }
    }

    protected getTagTypeSuggestion(keyword, limit) {


        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {
            filter: { keyword: keyword, limit: limit },
            pagination: this.tagStore.getTemplateViewModel().pagination,
        };
        let usrReq_url: string = '/api/brand/' + this.vnAppZone.app.params.idBrand + "/search/tag/type/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onTagTypeSuggestionReturn;
        this.XHRHdl.execute();
    }

    protected onTagTypeSuggestionReturn(req, obj) {
        return function () {
            obj.caller.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data.tagTypes) {

                    responseParsed.data.tagTypes.forEach((tagType) => {
                        tagType.typeName = tagType.name;
                        tagType.name += ` ${tagType.formattedDataset}`;
                        tagType.datasetName = tagType.dataset ? tagType.dataset.name : null;
                    })

                }
                obj.tagStore.tagTypeFilter.setOptions(responseParsed.data.tagTypes);
            });
        }
    }

    public similarSearchTags() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.tagStore.getTemplateViewModel().isLoadingResults(true);

        let usrReq_url: string = '/api/brand/' + this.vnAppZone.app.params.idBrand + "/search/similar/tag/";
        let usrReq_params: Array<Array<string>> = [];

        usrReq_params.push(["data", ko.toJSON(this.tagStore.getViewModelForSimilarSearch())]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.XHRHdl.onReadyStateFunction = this.onSimilarSearchTagsReturn;
        this.XHRHdl.execute();
    }

    protected onSimilarSearchTagsReturn(req, obj) {
        return function () {
            obj.caller.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.tagStore.setTags(responseParsed.data);
                obj.tagStore.pagination.setNumberItemToPaginate(responseParsed.totalCount);
            });
            obj.tagStore.getTemplateViewModel().isLoadingResults(false);
        }
    }

    public activateTag(idTag) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.tagStore.getTemplateViewModel().isLoadingActivate(true);

        let usrReq_url: string = '/api/brand/' + this.vnAppZone.app.params.idBrand + "/tags/activate/";
        let usrReq_params: Array<Array<string>> = [];
        let vm = this.tagStore.getViewModelForTagActivation(idTag);

        usrReq_params.push(["data", ko.toJSON(vm)]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onActivateTagReturn;
        this.XHRHdl.execute();

    }

    protected onActivateTagReturn(req, obj) {
        return function () {
            if (req.request.status == 400 && req.request.readyState == 4) {
                let responseParsed = JSON.parse(req.request.response);
                //To avoid syntax error
                const { validations } = responseParsed;
                obj.tagStore.validationsList.setMessages(validations);
                setTimeout( () => {
                    obj.tagStore.validationsList.clearMessages();
                }, 10000)
                obj.tagStore.getTemplateViewModel().isLoadingActivate(false);
            }
            obj.caller.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if(responseParsed.success){
                    const tagName = obj.tagStore.getTemplateViewModel().tagName();
                    const tagType = obj.tagStore.getTemplateViewModel().tagType();

                    // Tag Picker doesn't have its own module so have to check each one to find the correct caller.
                    if(obj.caller.articlesEdit) {
                        obj.tagPickerActivationSearch(obj.caller.articlesEdit, tagName, tagType);
                    }
                    if(obj.caller.listingPageEditTemplate) {
                        obj.tagPickerActivationSearch(obj.caller.listingPageEditTemplate, tagName, tagType);
                    }
                    if(obj.caller.newsletterMailEditTemplate) {
                        obj.tagPickerActivationSearch(obj.caller.newsletterMailEditTemplate, tagName, tagType);
                    }

                    obj.tagStore.getTemplateViewModel().isLoadingActivate(false);
                    obj.tagStore.onClickCancel();
                }
            });
        }
    }

    protected paginationOnPageClick() {
        this.similarSearchTags();
    }

    protected tagPickerActivationSearch(tagPickerParent, tagName, tagType) {
        if(tagPickerParent.tagPicker){
            tagPickerParent.tagPicker.getTemplateViewModel().filterTagSearch.filterKeyword(tagName);
            if(tagType.name != null) {
                tagPickerParent.tagPicker.getTemplateViewModel().selectedTagTypes([tagType]);
            } else {
                tagPickerParent.tagPicker.getTemplateViewModel().selectedTagTypes([]);
            }
            tagPickerParent.tagPicker.getTagData();
        }
    }

    public resetEditedSpec() {
        this.tagStore.resetEditedSpec();
    }

    protected getTagTypes(listTagTypesId) {
        if (listTagTypesId && listTagTypesId.length > 0) {
            this.XHRHdl.cancelAndReset();

            let usrReq_url: string = "/api/tag/types/get/";
            let usrReq_params: Array<Array<string>> = [];
            usrReq_params.push([
                "data",
                ko.toJSON({
                    filters: {
                        ids: listTagTypesId,
                    },
                }),
            ]);
            this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

            this.XHRHdl.onReadyStateFunction = this.onGetTagTypesReturn;
            this.XHRHdl.execute();
        }
    }

    protected onGetTagTypesReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                if (response.data) {
                    obj.tagStore.tagTypeFieldEdit.setTagTypesRestriction(
                        response.data
                    );
                }
            });
        };
    }

    public getTagsSuggestion(keyword, idElement) {

        this.XHRHdl.cancelAndReset();

        let tagTypeFieldParams = this.tagStore.tagTypeFieldEdit.getViewModelForRequest();
        let typeRestrictions = tagTypeFieldParams.typeRestrictions;

        let subViewModel = {keyword: keyword, tagTypesIds: typeRestrictions};
        let usrReq_url: string = '/api/tags/get_by_types/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetTagsSuggestionReturn;
        this.XHRHdl.execute();
    }

    protected onGetTagsSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                let tags = responseParsed.data;

                if (tags) {

                    obj.tagStore.tagTypeFieldEdit.setTags(tags);
                }

            });
        }
    }

    protected filterSimpleOnChange(idElement) {
        switch (idElement) {
          case "tagSourcePickerTagFilter":
            this.tagStore.tagTypeFieldEdit.addSelectedTag();
            break;
          default:
            break;
        }
      }
      protected filterSimpleCancel() {
        if (this.XHRHdl) {
          this.XHRHdl.cancelAndReset();
        }
      }

    protected validateTagSpecFromSource(idField, idType, label, dataType, restrictionsArray, value = null, idBrand = null) {

        this.tagStore.updateSpecification();
    }
}



// WEBPACK FOOTER //
// ./js/modules/tagStore_helper.ts